
import Hammer from 'hammerjs';

export default {
  data() {
    return {
      tab: 1,
      open: false,
      rotate: null,
      mc: {},
    };
  },
  created() {
    this.rotate = setInterval(this.handleRotate, 2500);
  },
  mounted() {
    this.mc = new Hammer.Manager(this.$refs.content);
    this.mc.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL }));
    this.mc.on('swiperight', this.back);
    this.mc.on('swipeleft', this.next);
  },
  beforeDestroy() {
    if (this.rotate) {
      clearInterval(this.rotate);
    }

    this.mc.off('swiperight', this.back);
    this.mc.off('swipeleft', this.next);
    this.mc.destroy();
  },
  methods: {
    handleTab(id) {
      this.tab = id;
      this.open = false;

      if (this.rotate) {
        clearInterval(this.rotate);
      }
    },
    go(step) {
      this.tab = this.tab + step;

      if (this.tab < 1) {
        this.tab = 4;
      }

      if (this.tab > 4) {
        this.tab = 1;
      }
    },
    back() {
      this.go(-1);

      if (this.rotate) {
        clearInterval(this.rotate);
      }
    },
    next() {
      this.go(1);

      if (this.rotate) {
        clearInterval(this.rotate);
      }
    },
    handleRotate() {
      this.go(1);
    },
  },
};
